// extracted by mini-css-extract-plugin
export default {"category":"LegendCategory_category__-Qe+3"};